import { IServiceTask, ServiceTaskStatus } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { BaseStateExtension } from '@common/state/state-extension';
import { ServiceTaskModelName } from 'src/app/shared/models/model-names';

export const SERVICES_APPOINTMENTS_TAB_SERVICE_TASK_STATE_NAME = 'ServicesAppointmentsTabServiceTask';

@Injectable({ providedIn: 'root' })
export class ServiceTabServiceTaskStateExtension extends BaseStateExtension<IServiceTask> {
  public name = ServiceTaskModelName;
  public patientIdToObserve: string = null;

  public async canBeStored(item: IServiceTask): Promise<boolean> {
    if (!this.patientIdToObserve || !item || item.archived) {
      return false;
    }

    const status = item.status?.toString().toLowerCase();
    const isCompleted = status === ServiceTaskStatus.Completed.toString().toLowerCase();

    return item.patientId === this.patientIdToObserve && !isCompleted;
  }

  protected afterCreateInternal(item: IServiceTask): void {
    this.stateRegistry.createBySync(ServiceTaskModelName, SERVICES_APPOINTMENTS_TAB_SERVICE_TASK_STATE_NAME, item);
  }

  protected afterUpdateInternal(item: IServiceTask): void {
    this.stateRegistry.updateBySync(ServiceTaskModelName, SERVICES_APPOINTMENTS_TAB_SERVICE_TASK_STATE_NAME, [item]);
  }

  protected removeFromState(item: IServiceTask): void {
    this.stateRegistry.removeBySync(ServiceTaskModelName, SERVICES_APPOINTMENTS_TAB_SERVICE_TASK_STATE_NAME, [item]);
  }
}
